__turbopack_context__.v({
  "accessibilityStatement": "yDQQMW_accessibilityStatement",
  "col": "yDQQMW_col",
  "head": "yDQQMW_head",
  "head2": "yDQQMW_head2",
  "head3": "yDQQMW_head3",
  "head4": "yDQQMW_head4",
  "head5": "yDQQMW_head5",
  "head6": "yDQQMW_head6",
  "head7": "yDQQMW_head7",
  "head8": "yDQQMW_head8",
  "head9": "yDQQMW_head9",
  "line": "yDQQMW_line",
  "link": "yDQQMW_link",
  "p": "yDQQMW_p",
  "rawLi": "yDQQMW_rawLi",
  "rawUl": "yDQQMW_rawUl",
  "row": "yDQQMW_row",
  "section": "yDQQMW_section",
  "section2": "yDQQMW_section2",
  "section3": "yDQQMW_section3",
  "section4": "yDQQMW_section4",
  "section5": "yDQQMW_section5",
  "section6": "yDQQMW_section6",
  "section7": "yDQQMW_section7",
  "section8": "yDQQMW_section8",
  "section9": "yDQQMW_section9",
  "text": "yDQQMW_text",
  "text10": "yDQQMW_text10",
  "text2": "yDQQMW_text2",
  "text3": "yDQQMW_text3",
  "text4": "yDQQMW_text4",
  "text5": "yDQQMW_text5",
  "text6": "yDQQMW_text6",
  "text7": "yDQQMW_text7",
  "text8": "yDQQMW_text8",
  "text9": "yDQQMW_text9",
  "title": "yDQQMW_title",
  "wrapper": "yDQQMW_wrapper",
});
